import React, { useContext } from 'react'
import AppContext from '../context/AppContext'
import SearchContext from '../context/SearchContext'


const Placeholder = () => {
    const {headless, path, hide_no_results, show_all_element_selector} = useContext(AppContext)
    const {params, handleParams, carsInStockTotal} = useContext(SearchContext)

    if( headless && hide_no_results) {

        if(show_all_element_selector) {
            document.querySelector(show_all_element_selector).remove();
        }

        return <></>;
    }

    return (
        <>
            { headless &&
                <div className="placeholder">
                    <h2>Hoppsan, just nu har vi inga i lager!</h2>
                    <p>Kanske har vi någon annan bil som kan vara intressant?</p>
                    <a href={`/${path}`} className="text-block passion">Se alla {carsInStockTotal} bilar i lager</a>
                </div>
            }
            { !headless &&
                <div className="placeholder">
                    <h2>Hoppsan, just nu har vi inga bilar som matchar din sökning!</h2>
                    <p>Kanske har vi någon annan bil som kan vara intressant?</p>
                    <a 
                        href={`/${path}`} 
                        className="text-block passion"
                        onClick={(e)=> {
                            e.preventDefault()
                            handleParams(new URLSearchParams())
                        }}
                    >Se alla {carsInStockTotal} bilar i lager</a>
                </div>
            }
        </>

    )
}

export default Placeholder